<template>
<div class="topNav">
    <div class="navContent">
      <div class="navLeft">
        <ul>
          <li style="margin-left:0px;"><a href="/"><img src="../../../../static/img/logo.png" alt="百运网国际快递" title="百运网-跨境物流智能服务平台"  width="78" height="26" style="margin-top:22px" /></a></li>
          <li><a href="/" class="bold" :class="isHig()==1?'active':''">首页</a></li>
           <li>
             <div class="tishi"><b class="font14"><a href="/landPageHome" target="_blank" :class="isHig()==2?'active':''">产品服务</a></b> <i class="fa marLf">&#xe620;</i>
                <div class="topTipBox">
                    <i style="left:7%;"></i>
                    <h3>产品服务</h3>
                    <p><a href="/landPageExp"><em class="fa fa-steps5 colIcon1" style="background:#0C5EE4;"></em>国际快递</a></p>
                    <p><a href="/landPageAir"><em class="fa fa-serIcon01 colIcon1" style="background:#0091FF;"></em>国际空运</a></p>
                    <p><a href="/landPageFBA"><em class="fa fa-serIcon03 colIcon1" style="background:#0C5EE4;"></em>FBA头程</a></p>
                    <p><a href="/landPageLine"><em class="fa fa-ZLineIcon colIcon1 font14" style="background:#0091FF;line-height:22px;"></em>国际专线</a></p>
                    <p><a href="/landPageSea"><em class="fa fa-serIcon04 colIcon1 font14" style="background:#0091FF;"></em>国际海运</a></p>
                    <p><a><em class="fa colIcon1 font14" style="background:#32C5FF;line-height:22px;">&#xe697;</em>国际小包</a></p>
                    <p><a href="/pickup/frontPickupCheck"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe60d;</em>国内取件</a></p> 
                </div>
              </div>
          </li>
           <li>
             <div class="tishi"><b class="font14"><a href="/Special/query-page/index.htm" target="_blank" :class="isHig()==3?'active':''">物流工具</a></b> <i class="fa marLf">&#xe620;</i>
                <div class="topTipBox topTipBox2" style="width:780px;">
                  <i style="left:5.5%;"></i>
                  <h3>查询工具</h3>                  
                    <p><a href="/Special/query-page/index.htm"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe6de;</em>国际快递查询</a></p>
                    <p><a href="/bywiki/customsCode"><em class="fa colIcon1" style="background:#0091FF;">&#xe6e4;</em>海关编码查询</a></p>
                    <p><a href="/bywiki/reportCode"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe6a6;</em>报关代码查询</a></p>
                    <p><a href="/bywiki/declareElements"><em class="fa colIcon1" style="background:#0091FF;">&#xe737;</em>申报要素查询</a></p>
                    <p><a href="/bywiki/airportCode"><em class="fa colIcon1" style="background:#0091FF;">&#xe704;</em>机场三字码查询</a></p>
                    <p><a href="/bywiki/shipCompany"><em class="fa colIcon1 font12" style="background:#32C5FF;">&#xe72d;</em>船运公司查询</a></p>
                    <p><a href="/bywiki/contaParameters"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe72f;</em>集装箱参数查询</a></p>
                    <p><a href="/bywiki/stowFactor"><em class="fa colIcon1" style="background:#32C5FF;">&#xe709;</em>积载因素查询</a></p>
                    <p><a href="/bywiki/deliveryArea"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe6df;</em>送货地址查询</a></p>
                    <p><a href="/bywiki/remoteArea"><em class="fa colIcon1 font12" style="background:#0C5EE4;">&#xe6e0;</em>偏远地址查询</a></p>
                    <div class="cl"></div>
                    <hr class="hrSet">
                    <h3>常用工具</h3>   
                    <p><a href="/bywiki/heavyCharge"><em class="fa colIcon1" style="background:#32C5FF;">&#xe6e3;</em>计费重计算器</a></p>
                    <p><a href="/bywiki/exchangeRate"><em class="fa colIcon1" style="background:#0C5EE4;">&#xe72a;</em>汇率换算器</a></p>
                    <p><a href="/bywiki/tradeTools"><em class="fa colIcon1" style="background:#32C5FF;">&#xe6e1;</em>外贸工具</a></p>
                   
                </div>
              </div>
          </li>
         <li><a href="/news.html" class="bold" :class="isHig()==4?'active':''">百运百科</a></li>
         <li>
            <div class="tishi"><b class="font14"><a href="/aboutBy/aboutByCent" target="_blank" :class="isHig()==5?'active':''">关于我们</a></b> <i class="fa marLf">&#xe620;</i>
              <div class="topTipBox topTipBox3" style="width:300px;"><i style="left:10.5%;"></i>
                  <h3>关于我们</h3>
                  <p><a href="/aboutBy/aboutByCent" rel='nofollow'><em class="fa colIcon1" style="background:#0C5EE4;">&#xe6f5;</em>关于百运</a></p>
                  <p><a href="/aboutBy/joinUs" rel='nofollow'><em class="fa colIcon1" style="background:#0C5EE4;">&#xe72b;</em>招贤纳士</a></p>
                  <p><a href="/aboutBy/agent" rel='nofollow'><em class="fa colIcon1" style="background:#0091FF;line-height:22px;">&#xe72e;</em>代理合作</a></p>
                  <p><a href="/aboutBy/contact" rel='nofollow'><em class="fa colIcon1" style="background:#0091FF;">&#xe72c;</em>联系我们</a></p>
              </div>
            </div>
          </li>         
        </ul>
      </div>
      <div class="navRight">
        <ul>
          <!-- <li><img src="../../../../static/img/top_tel.gif" />400 926 8156</li> -->
          <li v-if="!isLogin"><a  rel="nofollow" :href="this.$nuxtPage+`login/CSTCenter?ReturnUrl=${$route.fullPath}`">登录</a></li>
          <li v-if="!isLogin"><a  rel="nofollow" @click="clkReg" href="/reg/registerCst">免费注册</a></li>
          <!-- <li v-if="!isLogin"><a class="btnLine" @click="clkReg" :href="this.$apiAll+'CSTCenter/RegisterCst.aspx'">免费注册</a></li> -->
          <li v-if="isLogin"><a class="btnLine" :href="this.$apiAir+'customerCenter'"><i class="fa fa-topUser marR5" style="margin-top:-4px;"></i>我的百运</a></li>
          <li v-if="isLogin"><a :href="this.$apiAll+'CSTCenter/Logout.aspx'">退出登录</a></li>
        </ul>
      </div>
    </div>
</div>

</template>

<script type="text/ecmascript-6">

  import bus from '../../../ask/eventBus'
  import {fetch,post} from '../../../ask/axios'
  import {getCookie} from '../../../ask/cookiejs'

    export default {
      components: {

      },
      inject:['reload'],/*注入reload方法*/
      data(){
          return{
            api: {
              url: "",
              param: "",
              response: {},
              message: ""
            },

            isLogin:false, //是否登录

            NewbieList:[],
            QuestionList:[],
            
          }
      },
      created(){
        if(getCookie('JWT-TOKEN')){
          //this.getUserInfo();//客户信息接口
          this.isLogin=true
        }else{
          this.isLogin=false
        }

        this.getCatalogApi('UserGuide'); //头部帮助中心-新手指南接口
        this.getCatalogApi('CommonQuestion'); //头部帮助中心-常见问题
      },
      mounted(){

      },
      watch:{

      },
      methods:{

         //地址栏高亮显示
        isHig(){          
          if(this.$route.path=='/') return 1;
          if(this.$route.path=='/landPageHome') return 2;
          if(this.$route.path=='/Special/query-page/index.htm') return 3;
          if(this.$route.path=='/news.html') return 4;
          if(this.$route.path=='/aboutBy/aboutByCent') return 5;
        },

        //点击注册按钮
        clkReg(){
          this.clkRegBtn() //埋点，点击注册按钮获取入口
        },
        
        //帮助中心-新手指南 调用接口
        getCatalogApi(text){
          let that = this;
          this.api.param ={
            catalogCode:text
          }
          // this.api.url=this.$api02+"/api/EbayCustomer/NewsContent/GetNewsCatalogDataList";
          this.api.url=this.$api04 + "Basics/api/News/GetNewsCatalogDataList"
          fetch(this.api.url,this.api.param).then(function (res) {
            if(text=='UserGuide'){
              that.NewbieList=res.Results
            }
            if(text=='CommonQuestion'){
              that.QuestionList=res.Results
            }
          })
        },

      },

    }
</script>
<style type="text/css"  rel="stylesheet" scoped="scoped">
.topNav{height:70px;background:#fff;-moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);-webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);}
.topNav .mBy img{margin-top: 0;}
.topNav .mBy{ color: #636363;line-height: 1.5; padding: 15px 25px; font-weight: 400;}

.navContent{width:1200px;height:70px;margin:auto;}
.navContent .navLeft{float:left}
.navContent .navLeft ul li{line-height:70px;margin-right:30px;float:left;display:inline-block;cursor: pointer;}
.navContent .navLeft ul li a:hover{color:#0C5ee4;}
.navContent .navLeft ul li a{color:#666;font-size:14px;;}
.navContent .navLeft ul li a.active{border-bottom:2px solid #0C5ee4;padding-bottom:3px;}
.navContent .navLeft ul li.lineGary{color:#BABABA;margin:0 0px !important;}

.navContent .navRight{float:right;}
.navContent .navRight ul li{float:left;margin:25px 10px;font-size:14px;font-weight:bold;}
.navContent .navRight ul li img{vertical-align:middle;float:left}
.navContent .navRight ul li .btnLine{border:1px solid #0C5ee4;color:#0C5ee4;border-radius:30px;padding:6px 15px;font-size:14px;font-weight:bold}
.navContent .navRight ul li .imgLua{width:20px;height:20px;overflow:hidden;border:1px solid #ddd;display: inline-block;
  border-radius:100px;}

.setHelp p a{margin-left:20px;}


.tishi{position:relative;}
.tishi img{margin-top:6px;vertical-align:middle;cursor:pointer;}
.tishi:hover div{display:block;}
.tishi:hover .marLf{transform:rotate(180deg);
  -ms-transform:rotate(180deg); 	/* IE 9 */
  -moz-transform:rotate(180deg); 	/* Firefox */
  -webkit-transform:rotate(180deg); /* Safari å’Œ Chrome */
  -o-transform:rotate(180deg); 	/* Opera */
  
  }

.topTipBox{display:none;padding:10px 30px;border-radius:5px;position:absolute;left:-25px;top:60px;background:#fff;z-index:999;border:1px solid #ddd;box-shadow:3px 3px 3px rgba(0,0,0,0.05);width:550px;
}
.topTipBox i{background:url('../../../../static/img/arrow-icon-s.png') no-repeat;width:22px;height:12px;display:block;position:absolute;top:-12px;left:36%;z-index:9999;} 
.topTipBox h3{line-height:30px;font-size:14px;color:black;}
.topTipBox p{float:left;line-height:50px;width:21%;padding:0 10px}
.topTipBox p:hover{background-color:#e6f2ff; 
                -webkit-transition: background-color .8s; 
                -moz-transition: background-color .8s; 
                -ms-transition: background-color .8s; 
                -o-transition: background-color .8s; 
                transition: background-color .8s;
}

.topTipBox p a{color:#4a4a4a !important;}
.topTipBox2 p{width:17.2% !important;}
.topTipBox3 p{width:43% !important;}
.topTipBox .colIcon1{width:22px;height:22px;line-height:20px;text-align:center;border-radius:100px;color:#fff;margin-right:5px;font-size:12px;}
.hrSet{height:0px;background-color: #ebebeb;border-color:transparent;margin-top:10px;}

.tipBoxWidth{width:255px;}
.tipBoxWidth2{width:500px;}



</style>



// WEBPACK FOOTER //
// src/components/Reception/public/top.vue